module.exports = __webpack_public_path__ + "static/media/avatar.ca62ce7f.png";